import { Chart } from "chart.js";
import i18n from "./i18n";
import { getFontStackForLanguage } from "./utils/appFontStack";

function applyChartFont() {
  const lang = i18n.resolvedLanguage || i18n.language || "en";
  Chart.defaults.font.family = getFontStackForLanguage(lang);
}

applyChartFont();
i18n.on("languageChanged", applyChartFont);
